"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderCancellationInfoToString = exports.SUPER_LATE_CANCELLATION_BY_PARTNER_API_INFO = exports.LATE_CANCELLATION_BY_PARTNER_API_INFO = exports.CANCELED_BY_PARTNER_API_CANCELLATION_INFO = exports.CANCELED_BY_CUSTOMER_URGENT_OR_HOLIDAY = exports.ORDER_CANCELLATION_REASONS_WEBSITE = exports.ORDER_CANCELLATION_REASONS_MGMT = exports.ORDER_CANCELLATION_CATEGORIES_MGMT = void 0;
exports.ORDER_CANCELLATION_CATEGORIES_MGMT = ["Customer", "Driver", "Support"];
exports.ORDER_CANCELLATION_REASONS_MGMT = {
    Customer: [
        "Transportation issue",
        "Booked somewhere else",
        "No-show",
        "Upset with Daytrip about another trip",
        "Price change",
        "Flexible / super flexible cancellation",
        "Medical reasons",
        "Force majeure",
        "Other",
    ],
    Driver: [
        "Late pickup",
        "Mechanical issues",
        "Different vehicle/driver",
        "Child seat issues",
        "Forgot about the trip",
        "Unknown",
        "Other",
    ],
    Support: ["Mistake", "Wrong quote provided", "Other"],
};
exports.ORDER_CANCELLATION_REASONS_WEBSITE = [
    "Transportation issue",
    "Booked somewhere else",
    "Upset with Daytrip about another trip",
    "Price change",
    "Medical reasons",
    "Personal or family emergency",
    "Other",
];
exports.CANCELED_BY_CUSTOMER_URGENT_OR_HOLIDAY = {
    category: "Customer",
    reason: "Other",
    note: "Cancelled by the customer from the holiday or urgent order page",
};
exports.CANCELED_BY_PARTNER_API_CANCELLATION_INFO = {
    category: "Customer",
    reason: "Other",
    note: "Cancelled by the customer via the partner API",
};
exports.LATE_CANCELLATION_BY_PARTNER_API_INFO = {
    category: "Customer",
    reason: "Late cancellation",
    note: "Cancelled by the customer via the partner API in last 24 hours",
};
exports.SUPER_LATE_CANCELLATION_BY_PARTNER_API_INFO = {
    category: "Customer",
    reason: "Late cancellation",
    note: "Cancelled by the customer via the partner API in last 15 minutes",
};
const orderCancellationInfoToString = (info) => {
    return `${info.category}: ${info.reason}`;
};
exports.orderCancellationInfoToString = orderCancellationInfoToString;
//# sourceMappingURL=OrderCancellationInfo.js.map